(() => {
  if (window.PawveraCartSession) return;

  const nativeFetch = window.fetch.bind(window);
  const channel = typeof BroadcastChannel === 'function' ? new BroadcastChannel('pawvera-cart-session') : null;
  let revision = 0;
  let timer;

  const render = (cart) => {
    const count = Number(cart.item_count);
    if (!Number.isInteger(count) || count < 0) return;
    document.querySelectorAll('[data-pf-cart-count], [data-pw-cart-count]').forEach(node => {
      node.textContent = String(count);
    });
    document.querySelectorAll('cart-icon').forEach(icon => {
      if (typeof icon.renderCartBubble === 'function') {
        icon.renderCartBubble(count, false).catch(() => {});
      } else {
        const number = icon.querySelector('[ref="cartBubbleCount"]');
        if (number) {
          number.textContent = count < 100 ? String(count) : '';
          number.classList.toggle('hidden', count === 0);
        }
        icon.querySelector('[ref="cartBubble"]')?.classList.toggle('visually-hidden', count === 0);
        icon.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
      }
    });
  };

  const refresh = async () => {
    const request = ++revision;
    try {
      const response = await nativeFetch((window.Shopify?.routes?.root || '/') + 'cart.js', {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;
      const cart = await response.json();
      if (request === revision) render(cart);
    } catch {}
  };

  const schedule = () => {
    revision++;
    clearTimeout(timer);
    timer = setTimeout(refresh, 50);
  };

  if (typeof PerformanceObserver === 'function') {
    const observer = new PerformanceObserver(list => {
      const changed = list.getEntries().some(entry => {
        const url = new URL(entry.name, location.origin);
        return url.origin === location.origin && /\/cart\/(add|change|update|clear)(?:\.(?:js|json))?$/.test(url.pathname);
      });
      if (!changed) return;
      schedule();
      channel?.postMessage('changed');
    });
    observer.observe({ type: 'resource', buffered: true });
  }

  channel?.addEventListener('message', schedule);
  window.addEventListener('pageshow', schedule);
  window.addEventListener('focus', schedule);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') schedule();
  });
  ['shopify:section:load', 'cart:update', 'cart:updated', 'cart:refresh', 'cart:change', 'shopify:cart:updated'].forEach(name => {
    document.addEventListener(name, schedule);
  });

  window.PawveraCartSession = { refresh };
  schedule();
})();
